import { ThemeLayerConfig } from '../../themeLayerConfigApi';

export const placeNamesConfig: ThemeLayerConfig = {
  categories: [
    {
      id: 'placeNames',
      groupid: 1,
      name: {
        nb: 'Stedsnavn',
        nn: 'Stadnamn',
        en: 'Place names',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
    },
    {
      id: 'placeNameLanguages',
      groupid: 8,
      name: {
        nb: 'Språk',
        nn: 'Språk',
        en: 'Language',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
      parentId: 'placeNames',
    },
    {
      id: 'placeNameTypes',
      groupid: 3,
      name: {
        nb: 'Navnetype',
        nn: 'Namnetype',
        en: 'Name type',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
      parentId: 'placeNames',
    },
    {
      id: 'placeNameRecentDecisions',
      groupid: 10,
      name: {
        nb: 'Vedtak siste periode',
        nn: 'Vedtak siste periode',
        en: 'Decisions',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
      parentId: 'placeNames',
    },
    {
      id: 'placeNameWritingStatus',
      groupid: 4,
      name: {
        nb: 'Skrivemåtestatus',
        nn: 'Skrivemåtestatus',
        en: 'Spelling status',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
      parentId: 'placeNames',
    },
    {
      id: 'placeNameCaseStatus',
      groupid: 2,
      name: {
        nb: 'Navnesaksstatus',
        nn: 'Namnesaksstatus',
        en: 'Place name status',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.ssr2',
      parentId: 'placeNames',
    },
  ],
  layers: [
    // Place names by language
    {
      id: 'norwegianPlaceNames',
      name: {
        nb: 'Norsk',
        nn: 'Norsk',
        en: 'Norwegian',
      },
      layers: 'norsk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1013',
      queryable: false,
      legendLayerNames: ['norsk'],
    },
    {
      id: 'luleSamiPlaceNames',
      name: {
        nb: 'Lulesamisk',
        nn: 'Lulesamisk',
        en: 'Lule Sami',
      },
      layers: 'lulesamisk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1014',
      queryable: false,
      legendLayerNames: ['lulesamisk'],
    },
    {
      id: 'northernSamiPlaceNames',
      name: {
        nb: 'Nordsamisk',
        nn: 'Nordsamisk',
        en: 'Northern Sami',
      },
      layers: 'nordsamisk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1015',
      queryable: false,
      legendLayerNames: ['nordsamisk'],
    },
    {
      id: 'skoltSamiPlaceNames',
      name: {
        nb: 'Skoltesamisk',
        nn: 'Skoltesamisk',
        en: 'Skolt Sami',
      },
      layers: 'skoltesamisk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1016',
      queryable: false,
      legendLayerNames: ['skoltesamisk'],
    },
    {
      id: 'southernSamiPlaceNames',
      name: {
        nb: 'Sørsamisk',
        nn: 'Sørsamisk',
        en: 'Southern Sami',
      },
      layers: 'sorsamisk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1017',
      queryable: false,
      legendLayerNames: ['sorsamisk'],
    },
    {
      id: 'kvenPlaceNames',
      name: {
        nb: 'Kvensk',
        nn: 'Kvensk',
        en: 'Kven',
      },
      layers: 'kvensk',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1018',
      queryable: false,
      legendLayerNames: ['kvensk'],
    },
    {
      id: 'otherPlaceNames',
      name: {
        nb: 'Andre',
        nn: 'Andre',
        en: 'Other',
      },
      layers: 'andre',
      categoryId: 'placeNameLanguages',
      groupid: 8,
      legacyId: 'ssr.1019',
      queryable: false,
      legendLayerNames: ['andre'],
    },
    // Place names by type
    {
      id: 'administrativeAreasPlaceNames',
      name: {
        nb: 'Administrative områder',
        nn: 'Administrative område',
        en: 'Administrative areas',
      },
      layers: 'offentlig_administrasjon',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1020',
      queryable: false,
      legendLayerNames: ['offentlig_administrasjon'],
    },
    {
      id: 'settlementPlaceNames',
      name: {
        nb: 'Busetnad/eigedom',
        nn: 'Busetnad/eigedom',
        en: 'Settlement/property',
      },
      layers: 'bebyggelse',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1021',
      queryable: false,
      legendLayerNames: ['bebyggelse'],
    },
    {
      id: 'infrastructurePlaceNames',
      name: {
        nb: 'Samferdsel',
        nn: 'Samferdsle',
        en: 'Infrastructure',
      },
      layers: 'infrastruktur',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1022',
      queryable: false,
      legendLayerNames: ['infrastruktur'],
    },
    {
      id: 'seaPlaceNames',
      name: {
        nb: 'Sjø',
        nn: 'Sjø',
        en: 'Sea',
      },
      layers: 'sjo',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1023',
      queryable: false,
      legendLayerNames: ['sjo'],
    },
    {
      id: 'landTypePlaceNames',
      name: {
        nb: 'Markslag',
        nn: 'Markslag',
        en: 'Land types',
      },
      layers: 'markslag',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1024',
      queryable: false,
      legendLayerNames: ['markslag'],
    },
    {
      id: 'freshwaterPlaceNames',
      name: {
        nb: 'Ferskvann',
        nn: 'Ferskvatn',
        en: 'Freshwater',
      },
      layers: 'ferskvann',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1025',
      queryable: false,
      legendLayerNames: ['ferskvann'],
    },
    {
      id: 'terrainPlaceNames',
      name: {
        nb: 'Terrengformer',
        nn: 'Terrengformer',
        en: 'Terrain features',
      },
      layers: 'terreng',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1026',
      queryable: false,
      legendLayerNames: ['terreng'],
    },
    {
      id: 'culturePlaceNames',
      name: {
        nb: 'Kultur',
        nn: 'Kultur',
        en: 'Culture',
      },
      layers: 'kultur',
      categoryId: 'placeNameTypes',
      groupid: 3,
      legacyId: 'ssr.1027',
      queryable: false,
      legendLayerNames: ['kultur'],
    },
    // Writing status
    {
      id: 'approvedPlaceNames',
      name: {
        nb: 'Vedtatt',
        nn: 'Vedteke',
        en: 'Approved',
      },
      layers: 'vedtatt',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1038',
      queryable: false,
      legendLayerNames: ['vedtatt'],
    },
    {
      id: 'approvedNamePartPlaceNames',
      name: {
        nb: 'Vedtatt navneledd',
        nn: 'Vedteke namneledd',
        en: 'Approved name part',
      },
      layers: 'vedtatt_navneledd',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1039',
      queryable: false,
      legendLayerNames: ['vedtatt_navneledd'],
    },
    {
      id: 'acceptedPlaceNames',
      name: {
        nb: 'Godkjent skrivemåte',
        nn: 'Godkjent skrivemåte',
        en: 'Accepted spelling',
      },
      layers: 'godkjent',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1040',
      queryable: false,
      legendLayerNames: ['godkjent'],
    },
    {
      id: 'internationalPlaceNames',
      name: {
        nb: 'Internasjonalt',
        nn: 'Internasjonalt',
        en: 'International',
      },
      layers: 'internasjonalt',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1041',
      queryable: false,
      legendLayerNames: ['internasjonalt'],
    },
    {
      id: 'privatePlaceNames',
      name: {
        nb: 'Privat',
        nn: 'Privat',
        en: 'Private',
      },
      layers: 'privat',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1042',
      queryable: false,
      legendLayerNames: ['privat'],
    },
    {
      id: 'historicalPlaceNames',
      name: {
        nb: 'Historisk',
        nn: 'Historisk',
        en: 'Historical',
      },
      layers: 'historisk',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1043',
      queryable: false,
      legendLayerNames: ['historisk'],
    },
    {
      id: 'proposedPlaceNames',
      name: {
        nb: 'Foreslått',
        nn: 'Føreslege',
        en: 'Proposed',
      },
      layers: 'foreslatt',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1044',
      queryable: false,
      legendLayerNames: ['foreslatt'],
    },
    {
      id: 'unevaluatedPlaceNames',
      name: {
        nb: 'Uvurdert skrivemåte',
        nn: 'Uvurdert skrivemåte',
        en: 'Unevaluated',
      },
      layers: 'uvurdert',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1045',
      queryable: false,
      legendLayerNames: ['uvurdert'],
    },
    {
      id: 'rejectedNamePartPlaceNames',
      name: {
        nb: 'Avslått navneledd',
        nn: 'Avslege namneledd',
        en: 'Rejected name part',
      },
      layers: 'avslatt_navneledd',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1046',
      queryable: false,
      legendLayerNames: ['avslatt_navneledd'],
    },
    {
      id: 'rejectedPlaceNames',
      name: {
        nb: 'Avslått skrivemåte',
        nn: 'Avslått skrivemåte',
        en: 'Rejected spelling',
      },
      layers: 'avslatt',
      categoryId: 'placeNameWritingStatus',
      groupid: 4,
      legacyId: 'ssr.1047',
      queryable: false,
      legendLayerNames: ['avslatt'],
    },
    // Case status
    {
      id: 'caseStatusUntreatedPlaceNames',
      name: {
        nb: 'Navnesaksstatus ubehandlet',
        nn: 'Namnesaksstatus uhandsama',
        en: 'Case status untreated',
      },
      layers: 'navnesakstatus_ubehandlet',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1048',
      queryable: false,
      legendLayerNames: ['navnesakstatus_ubehandlet'],
    },
    {
      id: 'notToBeProcessedPlaceNames',
      name: {
        nb: 'Skal ikke behandles',
        nn: 'Skal ikkje handsamast',
        en: 'Not to be processed',
      },
      layers: 'skalikkebehandles',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1049',
      queryable: false,
      legendLayerNames: ['skalikkebehandles'],
    },
    {
      id: 'approvedByAuthorityPlaceNames',
      name: {
        nb: 'Vedtatt av navnemyndighet',
        nn: 'Vedteke av namnemyndet',
        en: 'Approved by naming authority',
      },
      layers: 'navnemyndighet',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1050',
      queryable: false,
      legendLayerNames: ['navnemyndighet'],
    },
    {
      id: 'collectiveDecisionPlaceNames',
      name: {
        nb: 'Samlevedtak',
        nn: 'Samlevedtak',
        en: 'Collective decision',
      },
      layers: 'samlevedtak',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1051',
      queryable: false,
      legendLayerNames: ['samlevedtak'],
    },
    {
      id: 'collectiveDecisionWithdrawnPlaceNames',
      name: {
        nb: 'Samlevedtak trukket tilbake',
        nn: 'Samlevedtak trekt tilbake',
        en: 'Collective decision withdrawn',
      },
      layers: 'samlevedtak_tilbake',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1052',
      queryable: false,
      legendLayerNames: ['samlevedtak_tilbake'],
    },
    {
      id: 'caseRaisedPlaceNames',
      name: {
        nb: 'Navnesak reist',
        nn: 'Namnesak reist',
        en: 'Name case raised',
      },
      layers: 'reist',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1053',
      queryable: false,
      legendLayerNames: ['reist'],
    },
    {
      id: 'caseDecisionPlaceNames',
      name: {
        nb: 'Navnesak vedtatt',
        nn: 'Namnesak vedteke',
        en: 'Name case decided',
      },
      layers: 'navnesak_vedtak',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1054',
      queryable: false,
      legendLayerNames: ['navnesak_vedtak'],
    },
    {
      id: 'decisionPostponedPlaceNames',
      name: {
        nb: 'Vedtak utsatt',
        nn: 'Vedtak utsett',
        en: 'Decision postponed',
      },
      layers: 'vedtakutsatt',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1055',
      queryable: false,
      legendLayerNames: ['vedtakutsatt'],
    },
    {
      id: 'appealDecisionNotWithdrawnPlaceNames',
      name: {
        nb: 'Klage, vedtak ikke trukket tilbake',
        nn: 'Klage, vedtak ikkje trekt tilbake',
        en: 'Appeal, decision not withdrawn',
      },
      layers: 'klage_ikke_trukket',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1056',
      queryable: false,
      legendLayerNames: ['klage_ikke_trukket'],
    },
    {
      id: 'appealDecisionWithdrawnPlaceNames',
      name: {
        nb: 'Klage, vedtak trukket tilbake',
        nn: 'Klage, vedtak trekt tilbake',
        en: 'Appeal, decision withdrawn',
      },
      layers: 'klage_trukket',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1057',
      queryable: false,
      legendLayerNames: ['klage_trukket'],
    },
    {
      id: 'appealDecisionPostponedPlaceNames',
      name: {
        nb: 'Klage, vedtak utsatt',
        nn: 'Klage, vedtak utsett',
        en: 'Appeal, decision postponed',
      },
      layers: 'klagevedtakutsatt',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1058',
      queryable: false,
      legendLayerNames: ['klagevedtakutsatt'],
    },
    {
      id: 'simplifiedDecisionPlaceNames',
      name: {
        nb: 'Forenklet vedtak',
        nn: 'Forenkla vedtak',
        en: 'Simplified decision',
      },
      layers: 'forenkletvedtak',
      categoryId: 'placeNameCaseStatus',
      groupid: 2,
      legacyId: 'ssr.1059',
      queryable: false,
      legendLayerNames: ['forenkletvedtak'],
    },
    // Recent decisions
    {
      id: 'decision24MonthsPlaceNames',
      name: {
        nb: 'Vedtak siste 24 mnd',
        nn: 'Vedtak siste 24 mnd',
        en: 'Decisions last 24 months',
      },
      layers: 'vedtak_24',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1028',
      queryable: false,
      legendLayerNames: ['vedtak_24'],
    },
    {
      id: 'decision12MonthsPlaceNames',
      name: {
        nb: 'Vedtak siste 12 mnd',
        nn: 'Vedtak siste 12 mnd',
        en: 'Decisions last 12 months',
      },
      layers: 'vedtak_12',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1029',
      queryable: false,
      legendLayerNames: ['vedtak_12'],
    },
    {
      id: 'decision6MonthsPlaceNames',
      name: {
        nb: 'Vedtak siste 6 mnd',
        nn: 'Vedtak siste 6 mnd',
        en: 'Decisions last 6 months',
      },
      layers: 'vedtak_6',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1030',
      queryable: false,
      legendLayerNames: ['vedtak_6'],
    },
    {
      id: 'decision3MonthsPlaceNames',
      name: {
        nb: 'Vedtak siste 3 mnd',
        nn: 'Vedtak siste 3 mnd',
        en: 'Decisions last 3 months',
      },
      layers: 'vedtak_3',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1031',
      queryable: false,
      legendLayerNames: ['vedtak_3'],
    },
    {
      id: 'decision1MonthPlaceNames',
      name: {
        nb: 'Vedtak siste mnd',
        nn: 'Vedtak siste mnd',
        en: 'Decisions last month',
      },
      layers: 'vedtak_1',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1032',
      queryable: false,
      legendLayerNames: ['vedtak_1'],
    },
    {
      id: 'collectiveDecision24MonthsPlaceNames',
      name: {
        nb: 'Samlevedtak siste 24 mnd',
        nn: 'Samlevedtak siste 24 mnd',
        en: 'Collective decisions last 24 months',
      },
      layers: 'samlevedtak24',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1033',
      queryable: false,
      legendLayerNames: ['samlevedtak24'],
    },
    {
      id: 'collectiveDecision12MonthsPlaceNames',
      name: {
        nb: 'Samlevedtak siste 12 mnd',
        nn: 'Samlevedtak siste 12 mnd',
        en: 'Collective decisions last 12 months',
      },
      layers: 'samlevedtak12',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1034',
      queryable: false,
      legendLayerNames: ['samlevedtak12'],
    },
    {
      id: 'collectiveDecision6MonthsPlaceNames',
      name: {
        nb: 'Samlevedtak siste 6 mnd',
        nn: 'Samlevedtak siste 6 mnd',
        en: 'Collective decisions last 6 months',
      },
      layers: 'samlevedtak6',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1035',
      queryable: false,
      legendLayerNames: ['samlevedtak6'],
    },
    {
      id: 'collectiveDecision3MonthsPlaceNames',
      name: {
        nb: 'Samlevedtak siste 3 mnd',
        nn: 'Samlevedtak siste 3 mnd',
        en: 'Collective decisions last 3 months',
      },
      layers: 'samlevedtak3',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1036',
      queryable: false,
      legendLayerNames: ['samlevedtak3'],
    },
    {
      id: 'collectiveDecision1MonthPlaceNames',
      name: {
        nb: 'Samlevedtak siste mnd',
        nn: 'Samlevedtak siste mnd',
        en: 'Collective decisions last month',
      },
      layers: 'samlevedtak1',
      categoryId: 'placeNameRecentDecisions',
      groupid: 10,
      legacyId: 'ssr.1037',
      queryable: false,
      legendLayerNames: ['samlevedtak1'],
    },
  ],
};
